import { firebaseClient } from "../firebaseClient";
import { getList } from "controllers/bookmark";
import { searchFromServer } from "controllers/search";
import urlSlug from 'url-slug';
import async from 'async';
import safeJsonStringify from 'safe-json-stringify';
import { getApiUrl } from "utils/ez4castConfig";

if (typeof window === "undefined")
    var sizeOf = require('image-size');

let extraStaticPages = [
    { params: { id: "trending", isResource: true, isDynamic: true, title: "Trending on X this month", link: "https://tweethunter.io/trending" } },
    { params: { id: "trending-week", isResource: true, isDynamic: true, title: "Trending on X this week", link: "https://tweethunter.io/trending-week" } },
    { params: { id: "trending-day", isResource: true, isDynamic: true, title: "Trending on X now", link: "https://tweethunter.io/trending-day" } },
] as any;

export const tools = [
    { title: "Best Time to Tweet", link: "https://tweethunter.io/besttimetotweet", description: "Find out when your followers are most active so you can tweet at the perfect time." },
    { title: "Unretweet", link: "https://tweethunter.io/unretweet", description: "Get a clean state on your profile by unretweeting everything you ever retweeted." },
    { title: "AI Tweet Generator", link: "https://tweethunter.io/generate-tweets", description: "Generate tweets based on great X creators" },
    { title: "Twemex", link: "https://tweethunter.io/twemex", description: "A browser extension that automatically surfaces the most interesting ideas." },
    { title: "Thread Finder", link: "https://tweethunter.io/thread-finder", description: "Find the best creators and get notified for their threads." },
    { title: "X Video Downloader", link: "https://tweethunter.io/twitter-video-downloader", description: "Download Videos from any tweets, fast and simple." },
    { title: "How much is your X account worth?", link: "https://tweethunter.io/how-much-your-twitter-is-worth", description: "Find out how much you could be making with your X account." },
    { title: "Generate Fake Tweets", link: "https://tweethunter.io/fake-tweet-generator", description: "Generate fake tweets for fun with pixel-perfect X UI." },
    { title: "X Id converter", link: "https://tweethunter.io/twitter-id-converter", description: "Easily convert X IDs to usernames and vice versa." },
    { title: "X Metrics Calculator", link: "https://tweethunter.io/metrics-calculator", description: "Find Detailed Analytics Insights for Any X Profile. Engagement rate, average views, and more.." },
    { title: "Tweet & X Post Deleter", link: "https://tweethunter.io/tweet-deleter", description: "The easy and free way to delete all your Tweets. Delete posts manually or create delete automation rules." },
    { title: "Your 2023 Recap On 𝕏", link: "https://tweethunter.io/your-2023-x-stats-in-video", description: "Get all your 2023 𝕏 metrics (followers, likes, etc.) in a free and super shareable animated video (or GIF)" },
    { title: "X Data Export Tool", link: "https://tweethunter.io/export-anything-from-twitter", description: "Exporting X data made easy with our user-friendly tool" },
];


export async function index(id, url, type, extraData = {}) {

    try {
        console.log("will index url: " + url);
        const db = firebaseClient.firestore();
        let indexDoc = await db.collection("zIndex").doc(id).get();
        if (!indexDoc?.exists) {
            let dataToSave = {
                dateAdded: new Date(),
                id,
                url,
                type,
                ...extraData,
            }
            await db.collection("zIndex").doc(id).set(dataToSave);
        }
    }
    catch (e) {
        console.log("Error in SEO index: ", e);
    }
}

export async function getAllUserBlogHomes() {

    const db = firebaseClient.firestore();
    let indexDocs = await db.collection("zIndex").where("type", "==", "profile").get();
    let urls = indexDocs.docs.map(doc => doc?.data()?.url) ?? [];

    urls = urls.filter(x => !x.includes("[twUserName]"));

    return urls
}

export async function getAllUserBlogPosts() {

    const db = firebaseClient.firestore();
    let indexDocs = await db.collection("zIndex").where("type", "==", "post").get();
    let urls = indexDocs.docs.map(doc => doc?.data()?.url) ?? [];

    return urls
}

export async function getAllPosts(conf = {} as any) {
    let isResource = conf.isResource ?? false;
    let paths = [] as any;
    // let paths = [];

    // let collection = !process.env.NODE_ENV || process.env.NODE_ENV === "development" ? "articlesDev" : "articles";
    let collection = "articles";

    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development" || process.env.CUSTOM_ENV == "dev")
        collection = "articlesDev";

    // console.log("getAllPosts", collection);
    const db = firebaseClient.firestore();
    let articlesDocs = await db.collection(collection).get();
    // let articles: any = articlesDocs.docs.map(doc => {return {...doc.data(), isMarkdown: true}});

    articlesDocs.forEach(doc => {
        let article = doc.data();
        article.dateCreated = article._createdBy?.timestamp?.toDate().toISOString() ?? new Date(2020, 1, 1).toISOString();
        article.dateLastModified = article._updatedBy?.timestamp?.toDate().toISOString() ?? new Date(2020, 1, 1).toISOString();
        if (article.ref) delete article.ref;
        if (article._createdBy) delete article._createdBy;
        if (article._updatedBy) delete article._updatedBy;
        if (article.generateMetaImage) delete article.generateMetaImage;
        if (article.notifyOnSlack) delete article.notifyOnSlack;

        article.id = article.id ?? doc.id;

        // if (article.slug) {
        //     article.id = article.slug;
        // }

        let formatedArticle: any = {
            params: article,
        }

        paths.push(formatedArticle);
    })

    // sort alphabetically by title
    paths = paths.sort((a, b) => {
        if (!a.params.title) return 1;
        if (isEmoji(a.params.title) || a.params.title < b.params.title) return -1;
        if (a.params.title > b.params.title) return 1;
        return 0;
    });
    // console.log("getAllPosts", paths.map(x => x.params.id));

    if (isResource) {
        //@ts-ignore
        paths = paths.filter(path => path.params.isResource);
    }

    paths = paths.concat(extraStaticPages);

    paths.forEach((path: any) => {
        path.params.link = path.params.link ?? (path.params.isResource ? "https://tweethunter.io/resources/" : "https://tweethunter.io/tweets/") + (path.params.slug ?? path.params.id);

        // create another version accessible through the slug
        // console.log(path.params.id);

        if (path.params.slug) {
            let copy = { params: { ...path.params } };
            copy.params.id = path.params.slug;
            copy.params.isCopy = true;
            paths.push(copy);
        }
    })

    return paths;
}

export async function getResourcePageParams(id) {

    // console.log(params);
    // console.log("getStaticProps - id: " + id);
    // let paths = await getAllPosts({isResource: true});
    let paths = await getAllPosts();

    let fullParams: any = paths.find(x => x.params.id === id || x.params.slug === id);

    if (fullParams) {
        let props: any = fullParams.params;

        props.data = {};
        props.data.tweets = [];
        props.data.tweets = await extractTweets(props.markdownPreCollection);
        props.data.collections = await extractCollections(props.markdownPreCollection);
        await extractImages(props);


        let postData = {
            ...props,
            id: id,
            displayedId: props.displayedId ?? id,
            page: id,
        }

        return { postData, paths };
    }

    return {};
}

export async function getTweetPageParams(id) {

    // console.log(params);
    // console.log("getStaticProps - id: " + id);
    let paths = await getAllPosts();
    let fullParams: any = paths.find(x => x.params.id === id || x.params.slug === id);
    let tweets = [];

    if (fullParams) {
        let props: any = fullParams.params;

        // console.log(props);
        // console.log("idUser: " + props.idUser);
        // console.log("idList: " + props.idList);

        if (props.idUser && props.idList) {
            tweets = await getList(props.idUser, props.idList);
        }
        else {
            let searchParams = {
                isPersonalizedSorting: false,
                nbMinDaysOld: 30,
                nbMaxDaysOld: 1000,
                nbMinLikes: 500,
                nbMinRt: 0,
                noHashtag: true,
                noDollar: true,
                nbMinCharacters: 30,
            }

            console.log("search: " + props.search);
            let search = props.search ?? id;
            search += " -http";

            //@ts-ignore
            let data = await searchFromServer(search, searchParams);
            // console.log({data});
            // console.log(data.tweets[0]);
            // console.log(data.tweets.map(x => x.extended_entities));
            // console.log(data.tweets.map(x => x.entities));
            // console.log("data nb: " + data?.tweets?.length);
            if (data && data.success) {
                tweets = data.tweets;
            }
        }

        tweets.forEach((tw: any) => {
            if (tw?.created_at?.toDate) {
                tw.created_at = tw.created_at.toDate();
            }
            if (tw?.dateAdded?.toDate) {
                tw.dateAdded = tw.dateAdded.toDate().toString();
            }
            if (tw?.user?.lastUpdated?.toDate) {
                tw.user.lastUpdated = tw.user.lastUpdated.toDate().toString();
            }
            if (tw?.user?.lastTweetFetchDate?.toDate) {
                tw.user.lastTweetFetchDate = tw.user.lastTweetFetchDate.toDate().toString();
            }
            if (tw?.created_at) {
                tw.created_at = tw.created_at.toString();
            }
            if (tw?.entities) {
                tw.entities = tw.entities && typeof tw.entities == "string" ? JSON.parse(tw.entities) : tw.entities;
            }
            if (tw.extended_entities) {
                tw.extended_entities = tw.extended_entities && typeof tw.extended_entities == "string" ? JSON.parse(tw.extended_entities) : tw.extended_entities;
            }
        });

        let postData = {
            ...props,
            id: id,
            displayedId: props.displayedId ?? id,
            page: id,
            tweets: tweets,
        }

        if (postData.isMarkdown) {
            postData.markdownPreCollection = props.markdownPreCollection;
            postData.markdownPostCollection = props.markdownPostCollection;
        }

        const stringifiedData = safeJsonStringify(postData);
        postData = JSON.parse(stringifiedData);

        return { postData, paths };
    }

    return {};
}

export async function getTweet(id) {

    const res = await fetch(`${getApiUrl("getTweet")}?idTweet=${id}`);
    const data = await res.json();

    if (data?.tweet) {
        let tweet = data.tweet;
        delete tweet._headers;
        delete tweet.place;

        return data.tweet
    }
    else {
        return null;
    }
}

function isEmoji(str) {
    var ranges = [
        '(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32-\ude3a]|[\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])' // U+1F680 to U+1F6FF
    ];
    if (str.match(ranges.join('|'))) {
        return true;
    } else {
        return false;
    }
}


async function extractImages(props) {

    let images = props?.images ?? [];
    let inBodyImages = props?.markdownPreCollection?.match(/!\[.*?\]\((.*?)\)/g) ?? [];
    inBodyImages = inBodyImages.filter(x => x.includes("https://"));
    inBodyImages = inBodyImages.map(x => {
        let url = x.replace(/!\[.*?\]\((.*?)\)/, "$1");
        return {
            downloadURL: url,
            name: url,
        }
    })
    images = images.concat(inBodyImages);

    if (images) {
        for await (let image of images) {

            try {
                console.log(image.name + ": " + image.downloadURL);
                let response = await fetch(image.downloadURL);
                //@ts-ignore
                // let buffer = await response.buffer();
                let imageDataArrayBuffer = await response.arrayBuffer();
                let buffer = Buffer.from(imageDataArrayBuffer);

                //@ts-ignore
                const dimensions = sizeOf(buffer);

                // console.log({dimensions});
                image.height = dimensions.height;
                image.width = dimensions.width;

                image.maxHeight = Math.min(image.width, 800) * image.height / image.width;
                image.maxWidth = "100%";
            }
            catch (e) {
                console.log(e);
            }
        }
    }

    props.images = images;
}

export async function createSlug(tweet) {

    if (!tweet)
        return;

    let title = tweet.blogTitle;
    if (!title) {
        let split = tweet.text?.split(" ");
        split = split.slice(0, 10);
        title = split.join(" ");
    }
    let slug = urlSlug(title);
    // console.log('title:', title)
    // console.log('slug:', slug)
    // console.log('tw:', tw)
    tweet.slug = slug;

    if (tweet.idUser && tweet.id) { // from TH user
        console.log("createSlug - save slug: " + slug);
        fetch(((!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? "http://localhost:3000" : "https://app.tweethunter.io") + "/api/saveSlug", {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ idUser: tweet.idUser, idTweet: tweet.id, slug }),
        });
    }
    else if (tweet.id_str) { // from ez4cast
        fetch(`${getApiUrl("saveSlug")}?idTweet=${tweet.id_str}&slug=${slug}`, {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ idTweet: tweet.id_str, slug }),
        });
    }
}

export async function extractCollections(text) {

    let collections = [] as any;

    let collectionUrls = text.match(/\bhttps:\/\/(app\.|)tweethunter\.io\/collection\?id=?[-a-zA-Z0-9@:%._\+~#=&]{1,256}/g);

    if (collectionUrls?.length > 0) {
        for await (let url of collectionUrls) {

            let { idUser, idList } = extractIdsFromCollectionUrl(url);

            let tweets = await getList(idUser, idList);
            // console.log("found collection " + idList + " with nbtweets: " + tweets?.length);

            tweets.forEach((tw: any) => {
                if (tw?.created_at?.toDate) {
                    tw.created_at = tw.created_at.toDate();
                }
                if (tw?.dateAdded?.toDate) {
                    tw.dateAdded = tw.dateAdded.toDate().toString();
                }
                if (tw?.user?.lastUpdated?.toDate) {
                    tw.user.lastUpdated = tw.user.lastUpdated.toDate().toString();
                }
                if (tw?.user?.lastTweetFetchDate?.toDate) {
                    tw.user.lastTweetFetchDate = tw.user.lastTweetFetchDate.toDate().toString();
                }
                if (tw?.created_at) {
                    tw.created_at = tw.created_at.toString();
                }
                if (tw?.entities) {
                    tw.entities = tw.entities && typeof tw.entities == "string" ? JSON.parse(tw.entities) : tw.entities;
                }
                if (tw.extended_entities) {
                    tw.extended_entities = tw.extended_entities && typeof tw.extended_entities == "string" ? JSON.parse(tw.extended_entities) : tw.extended_entities;
                }
            });

            let collection = { idList, idUser, tweets };
            collections.push(collection);
        }
    }

    return collections;
}

export function extractIdsFromCollectionUrl(url) {
    // console.log("url collection: " + url);
    const urlParams = new URLSearchParams(url);
    let idList = parseInt(urlParams.get('idList') ?? "");
    // let idUser = urlParams.get('id');
    let idUser = url.replace("https://tweethunter.io/collection?id=", "").split("&")[0];
    // console.log(idList, idUser);
    return { idUser, idList };
}

export async function extractTweets(text) {

    let tweets = [] as any;
    let tweetUrls = text.match(/\bhttps:\/\/twitter\.com\/(\w+)\/status\/(\d+)\b/g);
    if (tweetUrls?.length > 0) {
        // for await (let url of tweetUrls) {
        await async.mapLimit(tweetUrls, 5, async (url) => {
            try {
                let formatedId: any = url;
                formatedId = formatedId.split("/status/")[1].split("?")[0];
                console.log("formatedIds: ", formatedId);
                let tweet = await getTweet(formatedId);
                if (tweet) {
                    // console.log(tweet);
                    tweets.push(tweet);
                }
            }
            catch (e) {
                console.log(e);
            }
        });
    }

    return tweets;
}

